import React from 'react';

import PermissionCode from '@modules/roles/contantsPermissions';
import { IRouter } from '@routers/interface';

export const routerFormMember: IRouter = {
  path: '/member-and-partner/member/add',
  loader: React.lazy(() => import('./index')),
  exact: true,
  name: 'member.add', //translate here for breadcrumb and sidebar
  permissionCode: [PermissionCode.MEMBERS_CREATE, PermissionCode.CLUBS_CREATE_MEMBER],
};

export const routerFormMemberInfo: IRouter = {
  path: '/member-and-partner/member/:type/:id',
  loader: React.lazy(() => import('./index')),
  exact: true,
  name: 'member.view', //translate here for breadcrumb and sidebar
  permissionCode: PermissionCode.MEMBERS_VIEW,
};
